import { render, staticRenderFns } from "./EnemyItemInformation.vue?vue&type=template&id=276f160e&"
import script from "./EnemyItemInformation.vue?vue&type=script&lang=js&"
export * from "./EnemyItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports